var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4925 5.0351C18.2387 4.78141 17.8946 4.63889 17.5357 4.63889C17.1769 4.63889 16.8328 4.78141 16.579 5.0351L9.8805 11.7336L3.18201 5.0351C2.92679 4.7886 2.58496 4.6522 2.23014 4.65528C1.87533 4.65836 1.53592 4.80068 1.28502 5.05158C1.03412 5.30248 0.891806 5.64189 0.888723 5.9967C0.885641 6.35151 1.02204 6.69334 1.26854 6.94857L8.92377 14.6038C9.17754 14.8575 9.52167 15 9.8805 15C10.2393 15 10.5835 14.8575 10.8372 14.6038L18.4925 6.94857C18.7462 6.6948 18.8887 6.35066 18.8887 5.99183C18.8887 5.633 18.7462 5.28887 18.4925 5.0351Z",
    fill: "#02215F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/dropDownArrow.e71f173865c476a5ce958c6fdbe60918.svg";
export { ForwardRef as ReactComponent };